export const SAFE_TEXT_TO_HTML: (text: string | undefined) => string | undefined = (
  text: string | undefined,
): string | undefined =>
{
  return text;
  // let safeHtml: string | undefined;
  // if (
  //   text
  // ) {
  //   safeHtml = text.replaceAll(
  //     '\n',
  //     '<br/>'
  //   );
  //   // if (
  //   //   safeHtml.includes('**')
  //   // ) {
  //   //   const parts: string[] = safeHtml.split('**');
  //   //   let constructedHtml: string = '';
  //   //   parts.forEach((part, index) => {
  //   //     const tag: string = index % 2 === 0 ? '**' : '**';
  //   //     constructedHtml = `${constructedHtml}${part}${tag}`;
  //   //   });
  //   //   safeHtml = constructedHtml;
  //   // }
  // }
  // return safeHtml;
};
